import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchTrades } from "../../services/index";
import dayjs from "dayjs";
import "./../../assets/css/Style.css";
import { Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faStepBackward,
  faFastBackward,
  faStepForward,
  faFastForward,
  faSearch,
  faTimes,
  faSync,
  faChartLine,
  faCalendarAlt,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

class TradeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      API_URL: process.env.REACT_APP_API_ENDPOINT
        ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
        : "",
    histories: [],
    selectedHistoryId: '',
    isLoading: false,
      autoRefreshEnabled: false,
      showIChartSymbol: true,
      ph: false,
      showAutoRefresh: false,
      showPersistHistory: false,
      trades: [],
      report: [],
      search: "NIFTY 50",
      tradeDate: new Date().toISOString().slice(0, 10),
      currentPage: 1,
      tradesPerPage: 150,
      symbols: [
        { value: "NIFTY 50", display: "NIFTY" },
        { value: "NIFTY BANK", display: "BANK NIFTY" },
        { value: "NIFTY FIN SERVICE", display: "FINNIFTY" },
        { value: "SENSEX", display: "SENSEX" },
        { value: "BANKEX", display: "BANKEX" },
        { value: "NIFTY MID SELECT", display: "MIDCPNIFTY" },
      ],
      trade_types: [
        { value: "live", display: "Live" },
        { value: "paper", display: "Paper" },
      ],
      trade_type: "paper",
      algoNames: [
              { value: "CHEETAH_IOS", display: "Direction" },
              { value: "NON_DIRECTION", display: "Non Direction" },
              { value: "NON_DIRECTION_BTST", display: "NON DIRECTION BTST" },
              { value: "DIRECTION_BTST", display: "DIRECTION BTST" },
              { value: "DIRECTION_POSITIONAL", display: "DIRECTION POSITIONAL" },
              { value: "NON_DIRECTION_POSITIONAL", display: "NON DIRECTION POSITIONAL" }
            ],
      algoName: "CHEETAH_IOS",
      showLevelStrike: false,
      showLevelDelta: false,
      showLevelPcr: false,
      openingFilter: "",       // "", "GU", "GD", "SW"
      expiryFilter: "all",     // "all", "expiry", "nonExpiry"
      filteredDateList: [],    // dates filtered by opening type / expiry (descending)
      dateListLoading: false,
    };
  }

  handleClick = () => {
    this.state.showIChartSymbol = !this.state.showIChartSymbol;
  };

  componentDidMount() {}

  componentWillUnmount() {
    this.stopAutoRefresh();
  }

  startAutoRefresh = () => {
    this.findAllTradeBySymbolAndDateInterval = setInterval(
      this.findAllTradeBySymbolAndDate,
      15 * 1000,
    );
    this.findReportInterval = setInterval(this.findReport, 15 * 1000);
  };

  stopAutoRefresh = () => {
    clearInterval(this.findAllTradeBySymbolAndDateInterval);
    clearInterval(this.findReportInterval);
  };

  changePage = (event) => {
    this.setState({
      [event.target.name]: parseInt(event.target.value),
    });
  };

  firstPage = () => {
    if (this.state.currentPage > 1) {
      this.setState({ currentPage: 1 });
    }
  };

  prevPage = () => {
    if (this.state.currentPage > 1) {
      this.setState({ currentPage: this.state.currentPage - 1 });
    }
  };

  lastPage = () => {
    let tradesLength = this.props.tradeData.trades.length;
    if (this.state.currentPage < Math.ceil(tradesLength / this.state.tradesPerPage)) {
      this.setState({ currentPage: Math.ceil(tradesLength / this.state.tradesPerPage) });
    }
  };

  nextPage = () => {
    if (this.state.currentPage < Math.ceil(this.props.tradeData.trades.length / this.state.tradesPerPage)) {
      this.setState({ currentPage: this.state.currentPage + 1 });
    }
  };

  findAllTradeBySymbolAndDate = () => {
    axios
      .get(
        this.state.API_URL +
          "api/findTradeByIndexAndDate?indexName=" +
          this.state.search +
          "&date=" +
          this.state.tradeDate +
          "&tradeType=" +
          this.state.trade_type+"&algoName=" +
          this.state.algoName+"&dailyHistoryId="+this.state.selectedHistoryId,
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({ trades: data, currentPage: 1 });
      })
      .catch((error) => {
        console.log(error);
        localStorage.removeItem("jwtToken");
        this.props.history.push("/");
      });
  };

  findReport = () => {
    if (this.state.trades.length > 0) {
      axios
        .get(
          this.state.API_URL +
            "api/reportById?id=" +
            this.state.trades[0].dailyTradeId +
            "&tradeType=" +
            this.state.trade_type+"&algoName=" +
            this.state.algoName+"&dailyHistoryId="+this.state.selectedHistoryId,
        )
        .then((response) => response.data)
        .then((data) => {
          this.setState({ report: data, currentPage: 1 });
        })
        .catch((error) => {
          console.log(error);
          localStorage.removeItem("jwtToken");
          this.props.history.push("/");
        });
    }
  };

  fetchTradeHistory = async () => {
    if (this.state.isLoading) return;
    this.setState({ isLoading: true });
    try {
      const response = await axios.get(
      this.state.API_URL +'api/daily_trade/history',
        {
          params: {
            indexName: this.state.search,
            date: this.state.tradeDate,
            tradeType: this.state.trade_type,
            algoName: this.state.algoName
          }
        }
      );
      this.setState({ histories: response.data, isLoading: false });
    } catch (error) {
      console.error('Error fetching trade history:', error);
      this.setState({ isLoading: false });
    }
  };

  handleHistoryChange = (event) => {
    const selectedHistoryId = event.target.value;
    this.setState({ selectedHistoryId });
    if (this.props.onHistorySelect) {
      this.props.onHistorySelect(selectedHistoryId);
    }
  };

fetchFilteredDateList = (openingType, expiryFilterOverride) => {
  const expiryFilter = expiryFilterOverride !== undefined ? expiryFilterOverride : this.state.expiryFilter;
  if (!openingType && expiryFilter === "all") {
    this.setState({ filteredDateList: [] });
    return;
  }
  this.setState({ dateListLoading: true });
  const params = { indexName: this.state.search };
  if (expiryFilter === "expiry") {
    params.isExpiry = true;
  } else if (expiryFilter === "nonExpiry") {
    params.isExpiry = false;
  } else {
    // "all" with opening filter — keep existing non-expiry behavior
    params.isExpiry = false;
  }
  if (openingType) {
    params.openingType = openingType;
  }
  axios
    .get(this.state.API_URL + "api/exit-snapshot/date-list", { params })
    .then((response) => {
      const data = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
      const dates = data?.dates || [];
      this.setState({ filteredDateList: dates, dateListLoading: false });
      // Jump to nearest date in the list
      if (dates.length > 0 && !dates.includes(this.state.tradeDate)) {
        const nearest = dates.find((d) => d <= this.state.tradeDate) || dates[dates.length - 1];
        // Keep current index when expiry filter is active (user explicitly selected it)
        const ef = expiryFilterOverride !== undefined ? expiryFilterOverride : this.state.expiryFilter;
        const symbol = ef !== "all" ? this.state.search : this.getDefaultSymbolForDate(nearest);
        this.setState({ tradeDate: nearest, search: symbol }, () => {
          this.findAllTradeBySymbolAndDate();
        });
      }
    })
    .catch(() => this.setState({ filteredDateList: [], dateListLoading: false }));
};

handleOpeningFilterChange = (filter) => {
  const newFilter = this.state.openingFilter === filter ? "" : filter;
  this.setState({ openingFilter: newFilter }, () => {
    this.fetchFilteredDateList(newFilter);
  });
};

handleExpiryFilterChange = (e) => {
  const newExpiryFilter = e.target.value;
  this.setState({ expiryFilter: newExpiryFilter }, () => {
    if (newExpiryFilter === "all" && !this.state.openingFilter) {
      this.setState({ filteredDateList: [] });
    } else {
      this.fetchFilteredDateList(this.state.openingFilter, newExpiryFilter);
    }
  });
};

stepFilteredDate = (delta) => {
  const { filteredDateList, tradeDate, expiryFilter } = this.state;
  if (filteredDateList.length === 0) return;
  // filteredDateList is sorted descending
  const idx = filteredDateList.indexOf(tradeDate);
  const cur = idx >= 0 ? idx : filteredDateList.findIndex((d) => d <= tradeDate);
  const curIdx = cur >= 0 ? cur : 0;
  // delta +1 means next newer date (earlier index), -1 means older (later index)
  // But user expects +1 = forward in time, -1 = backward
  // descending list: index 0 = newest, so +1 = cur-1, -1 = cur+1
  const next = Math.max(0, Math.min(filteredDateList.length - 1, curIdx - delta));
  const nextDate = filteredDateList[next];
  // When expiry/nonExpiry filter is active, keep the current index (user explicitly selected it)
  // Only auto-detect index when using opening filter alone (no expiry filter)
  const symbol = expiryFilter !== "all" ? this.state.search : this.getDefaultSymbolForDate(nextDate);
  this.setState({ tradeDate: nextDate, search: symbol }, () => {
    this.findAllTradeBySymbolAndDate();
  });
};

getDefaultSymbolForDate = (date) => {
  const dateObj = dayjs(date);
  // Before June 2023: SENSEX data not available, always use NIFTY
  if (dateObj.isBefore(dayjs("2023-06-01"))) {
    return "NIFTY 50";
  }
  const dayOfWeek = dateObj.day();
  const year = dateObj.year();
    const month = dateObj.month() + 1;
  const isSept2025OrLater = year > 2025 || (year === 2025 && month >= 9);
  
    let defaultSymbol = "NIFTY 50";
  
  if (isSept2025OrLater) {
      if (dayOfWeek === 2) defaultSymbol = "NIFTY 50";
      else if (dayOfWeek === 3) defaultSymbol = "NIFTY 50";
      else if (dayOfWeek === 4) defaultSymbol = "SENSEX";
      else if (dayOfWeek === 5) defaultSymbol = "NIFTY 50";
  } else {
      if (dayOfWeek === 2) defaultSymbol = "SENSEX";
      else if (dayOfWeek === 3) defaultSymbol = "NIFTY 50";
      else if (dayOfWeek === 4) defaultSymbol = "NIFTY 50";
      else if (dayOfWeek === 5) defaultSymbol = "NIFTY 50";
    }
  return defaultSymbol;
};

hasFilteredNavigation = () => {
  return (this.state.openingFilter || this.state.expiryFilter !== "all") && this.state.filteredDateList.length > 0;
};

handlePrevDate = () => {
  if (this.hasFilteredNavigation()) {
    this.stepFilteredDate(-1);
    return;
  }
  const prevDate = dayjs(this.state.tradeDate).subtract(1, "day").format("YYYY-MM-DD");
  const defaultSymbol = this.getDefaultSymbolForDate(prevDate);
  this.setState({ tradeDate: prevDate, search: defaultSymbol }, () => {
    this.findAllTradeBySymbolAndDate();
  });
};

handleNextDate = () => {
  if (this.hasFilteredNavigation()) {
    this.stepFilteredDate(1);
    return;
  }
  const nextDate = dayjs(this.state.tradeDate).add(1, "day").format("YYYY-MM-DD");
  const defaultSymbol = this.getDefaultSymbolForDate(nextDate);
  this.setState({ tradeDate: nextDate, search: defaultSymbol }, () => {
    this.findAllTradeBySymbolAndDate();
  });
};

handleSevenPrevDate = () => {
  if (this.hasFilteredNavigation()) {
    this.stepFilteredDate(-7);
    return;
  }
  const prevDate = dayjs(this.state.tradeDate).subtract(7, "day").format("YYYY-MM-DD");
  const defaultSymbol = this.getDefaultSymbolForDate(prevDate);
  this.setState({ tradeDate: prevDate, search: defaultSymbol }, () => {
    this.findAllTradeBySymbolAndDate();
  });
};

handleSevenNextDate = () => {
  if (this.hasFilteredNavigation()) {
    this.stepFilteredDate(7);
    return;
  }
  const nextDate = dayjs(this.state.tradeDate).add(7, "day").format("YYYY-MM-DD");
  const defaultSymbol = this.getDefaultSymbolForDate(nextDate);
  this.setState({ tradeDate: nextDate, search: defaultSymbol }, () => {
    this.findAllTradeBySymbolAndDate();
  });
};

  findAllBooks() {
    axios
      .get(
        this.state.API_URL +
          "api/trade_list" +
          "?tradeType=" +
          this.state.trade_type+"&algoName=" +
            this.state.algoName,
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({ trades: data, currentPage: 1 });
      })
      .catch((error) => {
        console.log(error);
        localStorage.removeItem("jwtToken");
        this.props.history.push("/");
      });
  }

  searchChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handlePhChange = (event) => {
    this.setState({ ph: event.target.checked });
  };

  handleAutoRefreshChange = (event) => {
    const isChecked = event.target.checked;
    this.setState({ autoRefreshEnabled: isChecked });
    if (isChecked) {
      this.startAutoRefresh();
    } else {
      this.stopAutoRefresh();
    }
  };

  cancelSearch = () => {
    this.setState({ search: "" });
    this.findAllBooks();
  };

  searchData = () => {
    axios
      .get(
        this.state.API_URL +
          "api/findTradeByIndex?indexName=" +
          this.state.search +
          "&tradeType=" +
          this.state.trade_type+"&algoName=" +
          this.state.algoName,
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({ trades: data, currentPage: 1 });
      })
      .catch((error) => {
        console.log(error);
        localStorage.removeItem("jwtToken");
        this.props.history.push("/");
      });
  };

  generateReport = () => {
    const url =
      this.state.API_URL +
      `api/daily_generate_report?indexName=${this.state.search}&date=${this.state.tradeDate}&algoName=${this.state.algoName}&ph=${this.state.ph}`;
    axios.get(url).then((response) => console.log(response)).catch((error) => console.log(error));
  };

  toggleLevelMetric = (event) => {
    const { name, checked } = event.target;
    this.setState({ [name]: checked });
  };

  formatMetric = (value, decimals = 2) => {
    if (value === null || value === undefined || isNaN(Number(value))) return "-";
    const num = Number(value);
    return Number.isInteger(num) ? String(num) : num.toFixed(decimals);
  };

  renderLevelLine = (label, level) => {
    if (!level) return null;
    const { showLevelStrike, showLevelDelta, showLevelPcr } = this.state;
    const parts = [];
    if (showLevelStrike && (level.strikeCe !== undefined || level.strikePe !== undefined)) {
      parts.push(`Str:${level.strikeCe ?? "-"}/${level.strikePe ?? "-"}`);
    }
    if (showLevelDelta && (level.deltaCe !== undefined || level.deltaPe !== undefined)) {
      parts.push(`Δ:${this.formatMetric(level.deltaCe)}/${this.formatMetric(level.deltaPe)}`);
    }
    if (showLevelPcr && level.pcr !== undefined) {
      parts.push(`PCR:${this.formatMetric(level.pcr)}`);
    }
    if (parts.length === 0) return null;
    return <div>{label}: {parts.join(" ")}</div>;
  };

  renderLevelsCell = (trade) => {
    return (
      <div className="trade-levels">
        {this.renderLevelLine("En", trade.entryLevel)}
        {this.renderLevelLine("EnS", trade.entrySupportLevel)}
        {this.renderLevelLine("EnR", trade.entryResistanceLevel)}
        {this.renderLevelLine("Ex", trade.exitLevel)}
        {this.renderLevelLine("ExS", trade.exitSupportLevel)}
        {this.renderLevelLine("ExR", trade.exitResistanceLevel)}
      </div>
    );
  };

    formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })}`;
  };

  getRowClass = (trade) => {
    if (trade.is_leg) return 'trade-row-leg';
    if (trade.totalProfit > 0) return 'trade-row-profit';
    if (trade.totalProfit < 0) return 'trade-row-loss';
    return '';
  };

  getProfitClass = (value) => {
    if (value > 0) return 'trade-value-profit';
    if (value < 0) return 'trade-value-loss';
    return 'trade-value-neutral';
  };

  render() {
    const {
      trades,
      search,
      tradeDate,
      report,
      currentPage,
      tradesPerPage,
      trade_type,
      algoName,
      showIChartSymbol,
      ph,
      histories,
      selectedHistoryId,
      isLoading
    } = this.state;
    
    const lastIndex = currentPage * tradesPerPage;
    const firstIndex = lastIndex - tradesPerPage;
    const tradeData = trades;
    const currentTrades = trades && trades.slice(firstIndex, lastIndex);
    const totalPages = trades && Math.ceil(trades.length / tradesPerPage);
    const reportData = report == null ? null : report.value;

    return (
      <div className="trade-list-container">
        {tradeData.error ? (
          <Alert variant="danger">{tradeData.error}</Alert>
        ) : (
          <>
            {/* Header Controls - Single Row */}
            <div className="trade-controls">
              <div className="trade-controls-row">
                {/* Trade Type Toggle */}
                <div className="trade-type-group">
                  {this.state.trade_types.map((tt) => (
                    <button
                      key={tt.value}
                      className={`trade-type-btn ${trade_type === tt.value ? 'active' : ''}`}
                      onClick={() => this.setState({ trade_type: tt.value })}
                    >
                      {tt.display}
                    </button>
                  ))}
                </div>
                
                {/* Algo Select */}
                <select className="trade-select-sm" onChange={this.searchChange} name="algoName" value={algoName}>
                  {this.state.algoNames.map((algo) => (
                    <option key={algo.value} value={algo.value}>{algo.display}</option>
                  ))}
                </select>
                
                {/* Symbol Select */}
                <select className="trade-select-sm" onChange={this.searchChange} name="search" value={search}>
                  {this.state.symbols.map((symbol) => (
                    <option key={symbol.value} value={symbol.value}>{symbol.display}</option>
                  ))}
                </select>
                
                {/* History Select */}
                <select
                  className="trade-select-sm"
                  onFocus={this.fetchTradeHistory}
                  onClick={this.fetchTradeHistory}
                  onChange={this.handleHistoryChange}
                  value={selectedHistoryId}
                >
                  <option value="">{isLoading ? '...' : 'History'}</option>
                  {histories.map((history) => (
                    <option key={history.id} value={history.id}>{this.formatDateTime(history.historyDate)}</option>
                  ))}
                </select>

                {/* Toggles */}
                <label className="trade-toggle-sm">
                  <input type="checkbox" checked={this.state.autoRefreshEnabled} onChange={this.handleAutoRefreshChange} />
                  <span className="trade-toggle-switch-sm"></span>
                  <span className="trade-toggle-label-sm">AR</span>
                </label>
                
                <label className="trade-toggle-sm">
                  <input type="checkbox" name="ph" checked={ph} onChange={this.handlePhChange} />
                  <span className="trade-toggle-switch-sm"></span>
                  <span className="trade-toggle-label-sm">PH</span>
                </label>
                
                <label className="trade-toggle-sm">
                  <input type="checkbox" name="showLevelStrike" checked={this.state.showLevelStrike} onChange={this.toggleLevelMetric} />
                  <span className="trade-toggle-switch-sm"></span>
                  <span className="trade-toggle-label-sm">Str</span>
                </label>
                
                <label className="trade-toggle-sm">
                  <input type="checkbox" name="showLevelDelta" checked={this.state.showLevelDelta} onChange={this.toggleLevelMetric} />
                  <span className="trade-toggle-switch-sm"></span>
                  <span className="trade-toggle-label-sm">Δ</span>
                </label>
                
                <label className="trade-toggle-sm">
                  <input type="checkbox" name="showLevelPcr" checked={this.state.showLevelPcr} onChange={this.toggleLevelMetric} />
                  <span className="trade-toggle-switch-sm"></span>
                  <span className="trade-toggle-label-sm">PCR</span>
                </label>

                <button className="trade-gen-btn-sm" onClick={this.generateReport} title="Re-Generate Report">
                  <FontAwesomeIcon icon={faSync} />
                </button>
                
                {/* Expiry Filter */}
                <select
                  className="trade-select-sm"
                  value={this.state.expiryFilter}
                  onChange={this.handleExpiryFilterChange}
                  style={{ minWidth: 90 }}
                >
                  <option value="all">All</option>
                  <option value="expiry">Expiry</option>
                  <option value="nonExpiry">Non-Expiry</option>
                </select>

                {/* Opening Type Filter */}
                <div className="trade-type-group">
                  {["GU", "GD", "SW"].map((ot) => (
                    <button
                      key={ot}
                      className={`trade-type-btn ${this.state.openingFilter === ot ? 'active' : ''}`}
                      onClick={() => this.handleOpeningFilterChange(ot)}
                      style={this.state.openingFilter === ot ? {
                        backgroundColor: ot === "GU" ? "#d29922" : ot === "GD" ? "#f85149" : "#388bfd",
                        borderColor: ot === "GU" ? "#d29922" : ot === "GD" ? "#f85149" : "#388bfd",
                      } : {}}
                    >
                      {ot}
                    </button>
                  ))}
                </div>

                {/* Date Controls */}
                <div className="trade-date-controls">
                  <button className="trade-nav-btn-sm" onClick={this.handleSevenPrevDate}>-7</button>
                  <button className="trade-nav-btn-sm" onClick={this.handlePrevDate}><FontAwesomeIcon icon={faChevronLeft} /></button>
                  <input type="date" className="trade-date-input-sm" name="tradeDate" value={tradeDate} onChange={this.searchChange} />
                  <button className="trade-nav-btn-sm" onClick={this.handleNextDate}><FontAwesomeIcon icon={faChevronRight} /></button>
                  <button className="trade-nav-btn-sm" onClick={this.handleSevenNextDate}>+7</button>
                  <button className="trade-nav-btn-sm primary" onClick={() => { this.findAllTradeBySymbolAndDate(); this.findReport(); }}>
                    <FontAwesomeIcon icon={faSearch} />
                  </button>
                </div>
              </div>
            </div>
            
            {/* Trade Table */}
            <div className="trade-table-wrapper">
              <table className="trade-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Symbol</th>
                    <th title="Index Entry Price">IdxEn</th>
                    <th title="Index Exit Price">IdxEx</th>
                    <th title="IV" className="col-group-start">IV</th>
                    <th title="Vega">Vega</th>
                    <th title="Delta">Delta</th>
                    <th title="Total QNT" className="col-group-start">QNT</th>
                    <th title="Entry Time">ET</th>
                    {this.state.trade_type !== "paper" && <th title="Actual Entry Time">AET</th>}
                    <th title="Entry Price">EP</th>
                    {this.state.trade_type !== "paper" && <th title="Actual Entry Price">AEP</th>}
                    {this.state.trade_type !== "paper" && <th title="Live LTP">LiveP</th>}
                    <th title="Exit Time" className="col-group-start">ExT</th>
                    {this.state.trade_type !== "paper" && <th title="Actual Exit Time">AExT</th>}
                    <th title="Exit Price">ExP</th>
                    {this.state.trade_type !== "paper" && <th title="Actual Exit Price">AExP</th>}
                    {this.state.trade_type !== "paper" && <th title="Slipages">SLIP</th>}
                    <th title="Low Price" className="col-group-start">LP</th>
                    <th title="Low Price Time">LPT</th>
                    <th title="High Price">HP</th>
                    <th title="High Price Time">HPT</th>
                    {this.state.trade_type !== "paper" && <th title="Running Profit">RProfit</th>}
                    <th title="Stop Loss" className="col-group-start">SL</th>
                    <th title="Entry Trigger Type">EnType</th>
                    <th title="Exit Trigger Type">ExType</th>
                    <th title="Profit On This Trade" className="col-group-start">Pft</th>
                    {this.state.trade_type !== "paper" && <th title="Live Profit On This Trade">LvPft</th>}
                    <th title="Max Loss On This Trade">MxLoss</th>
                    <th title="Max Profit On This Trade">MxPft</th>
                    <th title="Entry/Exit Levels">Lvls</th>
                    <th title="IChart Link">Chart</th>
                  </tr>
                </thead>
                <tbody>
                  {trades.length === 0 ? (
                    <tr>
                      <td colSpan="30">
                        <div className="trade-empty">
                          <div className="trade-empty-icon">📊</div>
                          <div className="trade-empty-text">No trades found for selected criteria</div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    currentTrades.map((trade, index) => (
                      <tr key={index} className={this.getRowClass(trade)}>
                        <td className="trade-row-index">{firstIndex + index + 1}</td>
                        <td className="trade-symbol" onClick={this.handleClick}>
                          {showIChartSymbol ? trade.iChartSymbol : trade.symbol}
                        </td>
                        <td className="trade-price">{trade.entrySpotPrice}</td>
                        <td className="trade-price">{trade.exitSpotPrice}</td>
                        <td className="col-group-start" title={`${trade.entry_greek?.iv_o}`}>
                          {trade.entry_greek?.iv}, {trade.exit_greek?.iv}
                        </td>
                        <td title={`${trade.entry_greek?.vega_o}`}>
                          {trade.entry_greek?.vega}, {trade.exit_greek?.vega}
                        </td>
                        <td title={`${trade.entry_greek?.delta_o}`}>
                          {trade.entry_greek?.delta}, {trade.exit_greek?.delta}
                        </td>
                        <td className="col-group-start">{trade.quantity}</td>
                        <td className="trade-time">
                          {trade.entryOrder && trade.entryOrder.orderTimestamps && trade.tradeType !== "paper"
                            ? new Date(trade.entryOrder.orderTimestamps).toLocaleTimeString([], {
                                hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false
                              })
                            : trade.entryTime}
                        </td>
                        {this.state.trade_type !== "paper" && (
                          <td className="trade-time">
                            {trade.aEntryTime
                              ? new Date(trade.aEntryTime.replace("IST", "GMT+0530")).toLocaleTimeString([], {
                                  hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false
                                })
                              : ""}
                          </td>
                        )}
                        <td className="trade-price">{trade.entryPrice}</td>
                        {this.state.trade_type !== "paper" && <td className="trade-price">{trade.aEntryPrice}</td>}
                        {this.state.trade_type !== "paper" && <td className="trade-price">{trade.l_ltp}</td>}
                        <td className="trade-time col-group-start">
                          {trade.exitOrder && trade.exitOrder.orderTimestamps && trade.tradeType !== "paper"
                            ? new Date(trade.exitOrder.orderTimestamps).toLocaleTimeString([], {
                                hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false
                              })
                            : trade.exitTime}
                        </td>
                        {this.state.trade_type !== "paper" && (
                          <td className="trade-time">
                            {trade.aExitTime
                              ? new Date(trade.aExitTime.replace("IST", "GMT+0530")).toLocaleTimeString([], {
                                  hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false
                                })
                              : ""}
                          </td>
                        )}
                        <td className="trade-price">{trade.exitPrice}</td>
                        {this.state.trade_type !== "paper" && <td className="trade-price">{trade.aExitPrice}</td>}
                        {this.state.trade_type !== "paper" && <td>{trade.slippages}</td>}
                        <td className="col-group-start">{trade.low}</td>
                        <td className="trade-time">{trade.low_date_time}</td>
                        <td>{trade.high}</td>
                        <td className="trade-time">{trade.high_date_time}</td>
                        {this.state.trade_type !== "paper" && <td>{trade.running_profit}</td>}
                        <td className="col-group-start">{trade.stopLoss?.toFixed(2)}</td>
                        <td title={trade.entryInfo}>{trade.entryType}</td>
                        <td title={trade.exitInfo}>{trade.exitType}</td>
                        <td className={`col-group-start ${this.getProfitClass(trade.totalProfit)}`}>
                          {trade.totalProfit}
                        </td>
                        {this.state.trade_type !== "paper" && (
                          <td className={this.getProfitClass(trade.live_total_profit)}>
                            {trade.live_total_profit}
                          </td>
                        )}
                        <td className="trade-value-loss">{trade.quantity * trade.max_loss}</td>
                        <td className="trade-value-profit">{trade.quantity * trade.max_profit}</td>
                        <td>{this.renderLevelsCell(trade)}</td>
                        <td>
                          <a
                            href={trade.iChartSymbolURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="trade-chart-btn"
                          >
                            <FontAwesomeIcon icon={faChartLine} />
                          </a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
                </div>
            
            {/* Pagination */}
            {trades.length > 0 && (
              <div className="trade-pagination">
                <div className="trade-pagination-info">
                  Showing Page {currentPage} of {totalPages} ({trades.length} trades)
                </div>
                <div className="trade-pagination-controls">
                  <button
                    className="trade-nav-btn"
                    disabled={currentPage === 1}
                        onClick={this.firstPage}
                      >
                        <FontAwesomeIcon icon={faFastBackward} /> First
                  </button>
                  <button
                    className="trade-nav-btn"
                    disabled={currentPage === 1}
                        onClick={this.prevPage}
                      >
                        <FontAwesomeIcon icon={faStepBackward} /> Prev
                  </button>
                  <input
                    className="trade-pagination-input"
                      name="currentPage"
                      value={currentPage}
                      onChange={this.changePage}
                    />
                  <button
                    className="trade-nav-btn"
                    disabled={currentPage === totalPages}
                        onClick={this.nextPage}
                      >
                    Next <FontAwesomeIcon icon={faStepForward} />
                  </button>
                  <button
                    className="trade-nav-btn"
                    disabled={currentPage === totalPages}
                        onClick={this.lastPage}
                      >
                    Last <FontAwesomeIcon icon={faFastForward} />
                  </button>
                </div>
              </div>
            )}
            
            {/* Summary Report */}
            <div className="trade-summary">
              <div className="trade-summary-title">
                <FontAwesomeIcon icon={faChartLine} />
                Daily Summary Report
                <button
                  className="trade-nav-btn primary"
                  style={{ marginLeft: 'auto' }}
                        onClick={this.findReport}
                      >
                  <FontAwesomeIcon icon={faSearch} /> Refresh
                </button>
              </div>
              
                  {reportData == null ? (
                <div className="trade-empty">
                  <div className="trade-empty-text">No report data available. Click search to load.</div>
                </div>
              ) : (
                <>
                  <div className="trade-summary-grid">
                    <div className="trade-stat-card">
                      <div className="trade-stat-value">{reportData.index_name}</div>
                      <div className="trade-stat-label">Index</div>
                    </div>
                    <div className="trade-stat-card">
                      <div className="trade-stat-value">{reportData.opening_type}</div>
                      <div className="trade-stat-label">Opening Type</div>
                    </div>
                    <div className="trade-stat-card">
                      <div className="trade-stat-value">{reportData.future}</div>
                      <div className="trade-stat-label">Future</div>
                    </div>
                    <div className="trade-stat-card">
                      <div className="trade-stat-value">{reportData.total_trade_count}</div>
                      <div className="trade-stat-label">Total Trades</div>
                    </div>
                    <div className="trade-stat-card profit">
                      <div className="trade-stat-value profit">{reportData.trade_win_count}</div>
                      <div className="trade-stat-label">Wins</div>
                    </div>
                    <div className="trade-stat-card loss">
                      <div className="trade-stat-value loss">{reportData.trade_loss_count}</div>
                      <div className="trade-stat-label">Losses</div>
                    </div>
                    <div className="trade-stat-card">
                      <div className="trade-stat-value">{reportData.slippages}</div>
                      <div className="trade-stat-label">Slippages</div>
                    </div>
                    <div className="trade-stat-card">
                      <div className="trade-stat-value">{reportData.slippagesP}%</div>
                      <div className="trade-stat-label">Slippage %</div>
                    </div>
                    <div className={`trade-stat-card ${reportData.total_profit >= 0 ? 'profit' : 'loss'}`}>
                      <div className={`trade-stat-value ${reportData.total_profit >= 0 ? 'profit' : 'loss'}`}>
                        {reportData.total_profit?.toFixed(2)}
                      </div>
                      <div className="trade-stat-label">Total Profit</div>
                    </div>
                    <div className={`trade-stat-card ${reportData.total_profit_percentage >= 0 ? 'profit' : 'loss'}`}>
                      <div className={`trade-stat-value ${reportData.total_profit_percentage >= 0 ? 'profit' : 'loss'}`}>
                        {reportData.total_profit_percentage}%
                      </div>
                      <div className="trade-stat-label">Profit %</div>
                    </div>
                    <div className="trade-stat-card loss">
                      <div className="trade-stat-value loss">{reportData.loss}</div>
                      <div className="trade-stat-label">Loss Amount</div>
                    </div>
                    <div className="trade-stat-card">
                      <div className="trade-stat-value">{reportData.total_brokerages?.toFixed(2)}</div>
                      <div className="trade-stat-label">Brokerage</div>
                    </div>
                  </div>
                  
                  {/* Session Stats */}
                  <div className="trade-session-stats">
                    <div className="trade-session-card">
                      <div className="trade-session-title">1st Session</div>
                      <div className={`trade-session-value ${reportData.first_session_Profit >= 0 ? 'trade-value-profit' : 'trade-value-loss'}`}>
                        {reportData.first_session_Profit}
                      </div>
                      <div className="trade-session-range">
                        Max: {reportData.max_fsp} | Min: {reportData.min_fsp}
                      </div>
                    </div>
                    <div className="trade-session-card">
                      <div className="trade-session-title">2nd Session</div>
                      <div className={`trade-session-value ${reportData.second_session_Profit >= 0 ? 'trade-value-profit' : 'trade-value-loss'}`}>
                        {reportData.second_session_Profit}
                      </div>
                      <div className="trade-session-range">
                        Max: {reportData.max_ssp} | Min: {reportData.min_ssp}
                      </div>
                    </div>
                    <div className="trade-session-card">
                      <div className="trade-session-title">3rd Session</div>
                      <div className={`trade-session-value ${reportData.third_session_Profit >= 0 ? 'trade-value-profit' : 'trade-value-loss'}`}>
                        {reportData.third_session_Profit}
                      </div>
                      <div className="trade-session-range">
                        Max: {reportData.max_tsp} | Min: {reportData.min_tsp}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tradeData: state.trade,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTrades: () => dispatch(fetchTrades()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TradeList);
